import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Form, Input, Button, Typography, message, Space } from "antd";
import {
  UserOutlined,
  LockOutlined,
  FileTextOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

interface LoginPageProps {
  auth: {
    login: (username: string, password: string) => Promise<any>;
    error: string | null;
  };
}

export default function LoginPage({ auth }: LoginPageProps) {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      await auth.login(values.username, values.password);
      message.success("登录成功");
      navigate("/");
    } catch (error: any) {
      message.error(error.message || "登录失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <Card
        className="w-full max-w-md shadow-2xl"
        style={{ borderRadius: 16 }}
        bordered={false}
      >
        <div className="text-center mb-8">
          <Space direction="vertical" size={12} align="center">
            <div
              className="w-16 h-16 rounded-2xl flex items-center justify-center"
              style={{ background: "#e6f4ff" }}
            >
              <FileTextOutlined
                style={{ fontSize: 32, color: "#1890ff" }}
              />
            </div>
            <Title level={3} style={{ marginBottom: 0 }}>
              案件管理平台
            </Title>
            <Text type="secondary">矛盾化解案件管理系统</Text>
          </Space>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
          layout="vertical"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: "请输入用户名" }]}
          >
            <Input
              prefix={<UserOutlined style={{ color: "#bfbfbf" }} />}
              placeholder="请输入用户名"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: "请输入密码" }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: "#bfbfbf" }} />}
              placeholder="请输入密码"
            />
          </Form.Item>

          <Form.Item style={{ marginBottom: 16 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ height: 48, borderRadius: 8 }}
            >
              登录
            </Button>
          </Form.Item>
        </Form>

        <div className="text-center">
          <Text type="secondary" className="text-xs">
            测试账号: jia / yi / admin &nbsp;密码: 123456
          </Text>
        </div>
      </Card>
    </div>
  );
}
